<script>
import VueMultiselect from 'vue-multiselect'
import { mapState, mapActions } from 'vuex';
export default {
    name: "SendgridEvents",
    components: {
        VueMultiselect
    },
    data() {
        return {
            filters: {
                email: null,
                mailType: null,
                startTimestamp: null,
                endTimestamp: null
            }
        }
    },
    computed: {
        ...mapState({
            events: state => state.sendgrid.events,
            pagination: state => state.sendgrid.pagination,
            mailTypes: state => state.sendgrid.mailTypes
        })
    },
    mounted() {
        this.fetchEvents();
        this.fetchMailTypes();
    },
    methods: {
        ...mapActions('sendgrid', ['fetchEvents', 'changePage', 'setFilters', 'fetchMailTypes']),
        applyFilters() {
            this.setFilters({
                email: this.filters.email,
                start_timestamp: this.filters.startTimestamp,
                end_timestamp: this.filters.endTimestamp,
                mail_type: this.filters.mailType
            });
        },
        resetFilters() {
            this.setFilters({
                email: null,
                start_timestamp: null,
                end_timestamp: null,
                mail_type: null
            });

            this.filters.email = null;
            this.filters.startTimestamp = null;
            this.filters.endTimestamp = null;
            this.filters.mailType = null;
        }
    }
}
</script>

<template>
  <div>
    <h1>SendGrid Events</h1>
    <div class="filters">
      <div
        id="filter-input"
        class="mb-2"
      >
        <input
          v-model="filters.email"
          type="text"
          placeholder="Email"
          class="form-control"
        >
      </div>
      <div
        id="filter-select"
        class="mb-2"
      >
        <vue-multiselect
          v-model="filters.mailType"
          :options="mailTypes"
          :searchable="false"
          :close-on-select="true"
          :show-labels="true"
          placeholder="Select Mail Type"
        />
      </div>
      <!--      <input
        v-model="filters.startTimestamp"
        type="datetime-local"
        placeholder="Start Timestamp"
      >
      <input
        v-model="filters.endTimestamp"
        type="datetime-local"
        placeholder="End Timestamp"
      >-->
      <button
        class="btn btn-primary"
        @click="applyFilters"
      >
        Apply Filters
      </button>
      <button
        class="btn btn-info"
        @click="resetFilters"
      >
        Reset Filters
      </button>
    </div>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>From Email</th>
          <th>To Email</th>
          <th>Subject</th>
          <th>Email Type</th>
          <th>Status</th>
          <!--          <th>Timestamp</th>-->
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="event in events"
          :key="event.id"
        >
          <td>{{ event.message_payload.from_email }}</td>
          <td>{{ event.email }}</td>
          <td>{{ event.subject }}</td>
          <td>{{ event.mail_type }}</td>
          <td>{{ event.event }}</td>
          <!--          <td>{{ event.timestamp ? new Date(event.timestamp).toLocaleString() : '' }}</td>-->
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="pagination.last_page > 1"
      v-model="pagination.current_page"
      :total-rows="pagination.total"
      :per-page="pagination.per_page"
      @change="changePage"
    />
  </div>
</template>

<style scoped>
.filters {
    margin-bottom: 20px;
}

.filters input {
    margin-right: 10px;
}

.filters button {
    margin-right: 10px;
}
</style>
